<template>
  <div id="idle">
    <el-tabs type="border-card" @tab-click="tabChange" v-model="tab">
      <el-tab-pane label="已发布" name="0"></el-tab-pane>
      <el-tab-pane label="已卖出" name="2"></el-tab-pane>
      <el-tab-pane label="已下架" name="3"></el-tab-pane>
      <el-tab-pane label="审核未通过" name="1"></el-tab-pane>
    </el-tabs>
    <div style="background-color:#fff;padding:20px;min-height:600px">
      <el-row :gutter="30">
        <el-col :span="6" v-for="(item,index) of data" :key="index">
          <div class="obj">
            <div>
              <el-image
                style="width: 194px; height: 194px"
                :src="serve + '/'+_.split(item.images, ';', 1)"
                fit="cover"
              ></el-image>
            </div>
            <div class="t1 lv2Text">{{_.truncate(item.title,{'length':14})}}</div>
            <div class="lv0Text t2">
              <el-row>
                <el-col :span="12">
                  <div>&yen;{{item.selling_price}}</div>
                </el-col>
                <el-col :span="12">
                  <div align="right">
                    <el-button type="primary" size="mini" @click="view(item.id)">查看详情</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <div
        v-if="data==null"
        class="lv4Text"
        style="background-color:#fff;text-align:center;padding: 20px 0 50px 0;"
      >
        <span style="margin-right:5px">
          <i class="fas fa-box-open fa-lg"></i>
        </span>
        没有商品
      </div>
    </div>
    <div class="pager" align="center" v-if="total>0">
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        :total="total"
        :page-size="12"
        :current-page="page"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: 1,
      tab: "0",
      data: {},
      total: 0,
      empty1: false
    };
  },
  activated() {
    this.$store.state.user_location = "闲置交换";
  },
  created() {
    this.initData();
  },
  methods: {
    //
    view(id) {
      this.$router.push("/viewIdle?id=" + id);
    },
    pageChange(v) {
      this.page = v;
      this.load();
    },
    load() {
      var status = null;
      if (this.tab == 0) {
        status = null;
      } else {
        status = this.tab;
      }
      // console.log(status)
      this.axios
        .get(this.serve + "/exchange/my_exchange", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: this.page,
            status: status
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data = res.data.data.results;
            this.total = res.data.data.total;
            this.page = _.toInteger(res.data.data.page);
          } else {
            this.data = null;
            this.total = 0;
            this.page = 1;
          }
        });
    },
    tabChange(v) {
      this.tab = v.paneName;
      this.page = 1;
      this.load();
    },
    initData() {
      this.axios
        .get(this.serve + "/exchange/my_exchange", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: 1
          }
        })
        .then(res => {
          if (res.data.data) {
            this.empty1 = false;
            this.data = res.data.data.results;
            this.total = res.data.data.total;
            this.page = 1;
          } else {
            this.empty1 = true;
            this.data = null;
            this.total = 0;
            this.page = 1;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#idle {
  min-height: 600px;
  .el-tabs--border-card {
    border: 0;
    box-shadow: none;
    margin-bottom: -20px;
  }
  .obj {
    .t1 {
      padding: 8px 0;
      text-align: center;
    }
    border: 1px solid #ddd;
    padding: 10px;
    margin-bottom: 20px;
  }
}
</style>